function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { Tooltip, Typography } from 'seagull';
import { BundlePriceEditorContent } from "../../../../components/BundlePriceEditor";
import DiscountInput from "../../../../components/ServiceCreation/ServiceBuilder/DiscountInput";
import MinPriceTextField from "../../../../components/ServiceCreation/ServiceBuilder/MinPriceTextField";
import PriceTextField from "../../../../components/ServiceCreation/ServiceBuilder/PriceTextField";
import { getPriceAfterDiscount, serviceToInput } from "../../../../components/ServiceCreation/ServiceBuilder/ServiceBuilder.utils";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { DiscountModel, DiscountType, serviceCostModel, serviceModel } from "../../../../models";
import { isOneTimeInStages } from "../../../../models/service-billing";
import { utils } from "../../../../utils";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getPriceData } from "./service.utils";
import styles from "./ServiceRateCell.module.scss";
import { ServiceCostType } from "../../../../models/service-cost";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ServiceRateModalContent = _ref => {
  let {
    service,
    draft,
    setDraft
  } = _ref;
  const {
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(service));
  const {
    watch
  } = useFormContext();
  const [pricing, price, minPrice, discount] = watch(['pricing', 'price', 'minPrice', 'discount']);
  const discountedPrice = useMemo(() => getPriceAfterDiscount({
    pricing,
    price,
    minPrice,
    discount
  }), [pricing, price, minPrice, discount]);
  const changeService = transformer => {
    const newDraft = draft.setService(service.id, transformer);
    setDraft(newDraft);
  };
  const serviceData = useMemo(() => draft.service(service.id), [draft, service.id]);
  if (isBundle) {
    var _serviceData$bundle;
    return /*#__PURE__*/_jsx(BundlePriceEditorContent, {
      service: service,
      showActions: false,
      data: {
        bundleRate: (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.pricingType) === ServiceCostType.Fixed || (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.pricingType) === ServiceCostType.Variable ? (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.price.toNumber()) || 0 : 0,
        discount: serviceData !== null && serviceData !== void 0 && serviceData.cost.discount ? serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount.amount().toNumber() : '',
        discountType: serviceData !== null && serviceData !== void 0 && serviceData.cost.discount ? serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount.type() : DiscountType.Percent,
        includedServiceRates: (serviceData === null || serviceData === void 0 || (_serviceData$bundle = serviceData.bundle) === null || _serviceData$bundle === void 0 ? void 0 : _serviceData$bundle.services.reduce((acc, s) => {
          acc[s.serviceTemplateId || ''] = +s.rate;
          return acc;
        }, {})) || {}
      },
      onDataChange: _ref2 => {
        let {
          bundleRate,
          discount,
          discountType,
          includedServiceRates
        } = _ref2;
        return changeService(s => {
          var _serviceData$bundle2;
          return _objectSpread(_objectSpread({}, s), {}, {
            cost: _objectSpread(_objectSpread({}, s.cost), {}, {
              price: new Decimal(bundleRate),
              discount: +discount >= 0 ? DiscountModel.make(discountType, +discount) : null
            }),
            bundle: _objectSpread(_objectSpread({}, s.bundle), {}, {
              services: (serviceData === null || serviceData === void 0 || (_serviceData$bundle2 = serviceData.bundle) === null || _serviceData$bundle2 === void 0 ? void 0 : _serviceData$bundle2.services.map(s => _objectSpread(_objectSpread({}, s), {}, {
                rate: new Decimal(includedServiceRates[s.serviceTemplateId || ''])
              }))) || []
            })
          });
        });
      }
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.serviceRateForm,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.serviceRateContainer,
        children: [pricing === 'range' && /*#__PURE__*/_jsx(MinPriceTextField, {
          testid: "edit-service-rate-modal-min-price",
          onChange: value => changeService(s => _objectSpread(_objectSpread({}, s), {}, {
            cost: _objectSpread(_objectSpread({}, s.cost), {}, {
              minPrice: new Decimal(value || 0)
            })
          }))
        }), /*#__PURE__*/_jsx(PriceTextField, {
          testid: "edit-service-rate-modal-price",
          onChange: value => changeService(s => _objectSpread(_objectSpread({}, s), {}, {
            cost: _objectSpread(_objectSpread({}, s.cost), pricing === 'range' ? {
              maxPrice: new Decimal(value || 0)
            } : {
              price: new Decimal(value || 0)
            })
          }))
        })]
      }), /*#__PURE__*/_jsx(DiscountInput, {
        testid: "edit-service-rate-modal-discount",
        onChange: value => changeService(s => _objectSpread(_objectSpread({}, s), {}, {
          cost: _objectSpread(_objectSpread({}, s.cost), {}, {
            discount: +value.amount ? DiscountModel.make(value.type, +value.amount) : null
          })
        }))
      })]
    }), discountedPrice && /*#__PURE__*/_jsxs(Typography, {
      "data-testid": "edit-service-rate-modal-discounted-price",
      children: ["Price after discount: ", discountedPrice]
    })]
  });
};
export default function ServiceRateCell(_ref3) {
  let {
    index,
    service,
    isDisabled,
    disabledTooltip,
    onOpenModal
  } = _ref3;
  const {
    IN_STAGES_OCCURENCE = false
  } = useFeatureFlags();
  const defaultValues = useMemo(() => serviceToInput({
    service,
    qboItems: [],
    xeroItems: [],
    IN_STAGES_OCCURENCE
  }), [service, IN_STAGES_OCCURENCE]);
  const form = useForm({
    mode: 'all',
    defaultValues
  });
  const {
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(service));
  const onClick = () => {
    form.reset(defaultValues);
    onOpenModal({
      width: '450px',
      renderContent: _ref4 => {
        let {
          draft,
          setDraft
        } = _ref4;
        return {
          title: "".concat(isBundle ? 'Bundle' : 'Service', " rate"),
          testid: "edit-service-rate-modal-".concat(index),
          content: /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
            children: /*#__PURE__*/_jsx(ServiceRateModalContent, {
              service: service,
              draft: draft,
              setDraft: setDraft
            })
          })),
          onSubmit: defaultBehavior => {
            form.handleSubmit(defaultBehavior)();
          }
        };
      }
    });
  };
  const {
    price,
    discountedPrice,
    hasDiscount
  } = getPriceData(service.cost);
  const isVariable = serviceCostModel.isVariablePrice(service.cost);
  const unitName = serviceCostModel.formattedUnitNameShort(service.cost);
  const error = isOneTimeInStages(service.billing) && service.cost.discount && !service.cost.discount.isPercent();
  const title = discountedPrice == null ? '' : discountedPrice instanceof Decimal ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [utils.formatDollarAmount(discountedPrice), price instanceof Decimal && hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsx("del", {
        "data-testid": "service-rate-before-discount-".concat(index),
        children: utils.formatDollarAmount(price)
      })]
    }), isVariable && " / ".concat(unitName)]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [discountedPrice.minPrice instanceof Decimal && /*#__PURE__*/_jsxs(_Fragment, {
      children: [utils.formatDollarAmount(discountedPrice.minPrice), ' - ']
    }), discountedPrice.minPrice == null && 'Up to ', discountedPrice.maxPrice instanceof Decimal ? utils.formatDollarAmount(discountedPrice.maxPrice) : '', price != null && !(price instanceof Decimal) && hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsxs("del", {
        "data-testid": "service-rate-before-discount-".concat(index),
        children: [price.minPrice instanceof Decimal && /*#__PURE__*/_jsxs(_Fragment, {
          children: [utils.formatDollarAmount(price.minPrice), ' - ']
        }), price.maxPrice instanceof Decimal ? utils.formatDollarAmount(price.maxPrice) : '']
      })]
    })]
  });
  const tooltipTitle = error ? 'When the billing trigger is set to ‘In stages’, the discount can only be applied as a percentage' : title;
  const discountSubheader = service.cost.discount && service.cost.discount.amount().gt(0) && service.cost.discount.format();
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-service-rate-cell-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: tooltipTitle,
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography, {
          skin: error ? 'error' : 'standard',
          "aria-invalid": !!error,
          "data-testid": "service-rate-".concat(index),
          ellipsis: true,
          hideTooltip: true,
          children: title
        }), discountSubheader && /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: error ? 'error' : 'secondary',
          "data-testid": "service-rate-".concat(index, "-discount-subheader"),
          children: "".concat(discountSubheader, " discount")
        })]
      })
    })
  });
}